<template>
    <div class="wang-editor-container">
        <div ref="toolbarRef" class="editor-toolbar"></div>
        <div ref="editorRef" class="editor-text"></div>
        <div v-if="errorMsg" class="editor-error">{{ errorMsg }}</div>
    </div>
</template>

<script>
import E from 'wangeditor'
import { fileUpload } from '../api.js'

export default {
    name: 'WangEditor',
    props: {
        value: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        maxLength: {
            type: Number,
            default: 0
        },
        customConfig: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            editor: null,
            errorMsg: ''
        }
    },
    watch: {
        value: {
            immediate: true,
            handler(newVal) {
                if (this.editor && newVal !== this.editor.txt.html()) {
                    this.editor.txt.html(newVal)
                }
            }
        },
        disabled(newVal) {
            if (this.editor) {
                newVal ? this.editor.disable() : this.editor.enable()
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.initEditor()
        })
    },
    beforeDestroy() {
        if (this.editor) {
            this.editor.destroy()
            this.editor = null
        }
    },
    methods: {
        initEditor() {
            if (!this.$refs.editorRef) {
                this.errorMsg = '编辑器容器初始化失败'
                return
            }
            this.editor = new E(this.$refs.toolbarRef, this.$refs.editorRef)
            const baseConfig = {
                // 取消默认的网络图片上传
                uploadImgShowBase64: false,
                // 隐藏网络图片上传按钮
                showLinkImg: false,
                menuKeys: [
                    'head', // 标题
                    'bold', // 粗体
                    'italic', // 斜体
                    'underline', // 下划线
                    'strikeThrough', // 删除线
                    'list', // 列表
                    'justify', // 对齐方式
                    'link', // 链接
                    'image', // 图片
                    'table', // 表格
                    'undo', // 撤销
                    'redo' // 重做
                ],
                onchange: (html) => {
                    if (this.maxLength > 0) {
                        const textLength = this.editor.txt.text().length
                        this.errorMsg = textLength > this.maxLength
                            ? `内容不能超过${this.maxLength}个字`
                            : ''
                    }
                    this.$emit('input', html)
                    this.$emit('change', html)
                },
                uploadImgServer: '',
                customUploadImg: (resultFiles, insertImgFn) => {
                    this.uploadImage(resultFiles, insertImgFn)
                }
            }
            Object.assign(this.editor.config, baseConfig, this.customConfig)
            this.editor.create()
            if (this.value) {
                this.editor.txt.html(this.value)
            }
            if (this.disabled) {
                this.editor.disable()
            }
        },
        async uploadImage(resultFiles, insertImgFn) {
            const file = resultFiles[0]
            if (!file) return
            try {
                const formData = new FormData()
                formData.append('file', file)
                const res = await fileUpload(formData)
                if (res.code === 0 && res.data) {
                    insertImgFn(res.data)
                    this.errorMsg = ''
                } else {
                    this.errorMsg = res.msg || '图片上传失败'
                }
            } catch (err) {
                this.errorMsg = '图片上传出错，请重试'
                console.error('图片上传失败：', err)
            }
        },
        getContent() {
            return this.editor ? this.editor.txt.html() : ''
        },
        clearContent() {
            if (this.editor) {
                this.editor.txt.html('')
                this.$emit('input', '')
            }
        }
    }
}
</script>

<style scoped>
.wang-editor-container {
    width: 100%;
    border: 1px solid #e6e6e6;
    border-radius: 4px;
    box-sizing: border-box;
}

.editor {
    min-height: 300px;
    padding: 10px;
    box-sizing: border-box;
}

.editor-error {
    padding: 0 10px;
    height: 24px;
    line-height: 24px;
    font-size: 12px;
    color: #f56c6c;
    background-color: #fef0f0;
    box-sizing: border-box;
}

::v-deep .w-e-toolbar {
    border-bottom: 1px solid #e6e6e6;
    background-color: #f8f9fa;
    padding: 0 10px;
}

::v-deep .w-e-text-container {
    background-color: #fff;
    height: auto !important;
    min-height: 280px;
}

::v-deep .w-e-disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
}

.wang-editor-container {
    width: 100%;
    border: 1px solid #e6e6e6;
    border-radius: 4px;
    box-sizing: border-box;
    position: relative;
}

.editor-toolbar {
    position: sticky;
    top: 0;
    z-index: 10000000000000;
    background-color: #f8f9fa;
    border-bottom: 1px solid #e6e6e6;
    padding: 0 10px;
}

.editor-text {
    height: 500px;
    padding: 10px;
    box-sizing: border-box;
    overflow: auto;
}

.editor-error {
    padding: 0 10px;
    height: 24px;
    line-height: 24px;
    font-size: 12px;
    color: #f56c6c;
    background-color: #fef0f0;
    box-sizing: border-box;
}
</style>